import React from "react";

const LoginRecords = () => {
  return (
    <div className="">
      {/* Search Bar */}
      <div className="mt-4">
        <input
          type="text"
          placeholder="Search by name"
          className="w-full border rounded-md p-2 text-sm"
        />
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-100 text-gray-600">
            <tr>
              <th className="py-2 px-4">User Name</th>
              <th className="py-2 px-4">Login time</th>
              <th className="py-2 px-4">Login Date</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {[].map((loan, idx) => (
              <tr key={idx} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{loan.id}</td>
                <td className="py-2 px-4">{loan.amount}</td>
                <td className="py-2 px-4">{loan.repayment}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LoginRecords;
